import type { GoogleMapsInitializer, GoogleMapsLibraries } from './initializer';

export class GoogleMapsAPI {
	private googleMaps: GoogleMapsInitializer;

	constructor(googleMaps: GoogleMapsInitializer) {
		this.googleMaps = googleMaps;
	}

	public async getLibrary(library: GoogleMapsLibraries) {
		await this.googleMaps.isInitialized();
		return google.maps.importLibrary(library);
	}

	public async getLibraries(
		libraries?: GoogleMapsLibraries | GoogleMapsLibraries[]
	): Promise<Partial<Record<GoogleMapsLibraries, any>> | null> {
		await this.googleMaps?.isInitialized();
		const options = this.googleMaps.getOptions();

		const finalLibraries = libraries || options.libraries;

		if (!finalLibraries) {
			return null;
		}

		if (!Array.isArray(finalLibraries)) {
			const library = finalLibraries;
			const lib = await this.getLibrary(library);

			return {
				[library]: lib
			};
		}

		const loadLibraries = finalLibraries.map(async lib => [
			lib,
			await this.getLibrary(lib)
		]);

		const loadedLibraries = await Promise.all(loadLibraries);

		return loadedLibraries.reduce((api, lib) => {
			const [key, library] = lib;

			return {
				...api,
				[key as string]: library
			};
		}, {});
	}
}
